/* Modulo: Review Rail — native scroll-snap review rail.
   Vanilla IIFE, theme-editor aware, reduced-motion aware. No deps. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(el) {
    if (!el || el.dataset.moduloTrInit === '1') return; // idempotent — editor re-renders
    el.dataset.moduloTrInit = '1';

    var track = el.querySelector('[data-modulo-tr-track]');
    if (!track) return;

    var prev = el.querySelector('[data-modulo-tr-prev]');
    var next = el.querySelector('[data-modulo-tr-next]');

    function step() {
      var card = track.querySelector('.modulo-tr__card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 34;
      return card.getBoundingClientRect().width + gap;
    }
    function maxScroll() { return track.scrollWidth - track.clientWidth - 2; }
    function update() {
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= maxScroll();
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    function onPrev() { pauseAutoplay(); track.scrollBy({ left: -step() }); }
    function onNext() { pauseAutoplay(); track.scrollBy({ left: step() }); }
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);

    var raf = null;
    function onScroll() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; update(); });
    }
    track.addEventListener('scroll', onScroll);

    // ─── Autoplay (opt-in; pauses on hover, focus, and touch; resumes on leave/blur; off under reduced motion) ───
    var autoplayOn = el.getAttribute('data-autoplay') === 'true' && !REDUCE;
    var interval = parseInt(el.getAttribute('data-autoplay-interval'), 10);
    if (!interval || isNaN(interval)) interval = 5000;
    interval = Math.max(2500, interval);
    var timer = null;

    function tick() {
      if (track.scrollLeft >= maxScroll() - step() * 0.5) track.scrollTo({ left: 0 });
      else track.scrollBy({ left: step() });
    }
    function startAutoplay() {
      if (!autoplayOn || timer || maxScroll() <= 2) return;
      timer = window.setInterval(tick, interval);
    }
    function pauseAutoplay() { if (timer) { window.clearInterval(timer); timer = null; } }

    el.addEventListener('mouseenter', pauseAutoplay);
    el.addEventListener('mouseleave', startAutoplay);
    el.addEventListener('focusin', pauseAutoplay);
    el.addEventListener('focusout', startAutoplay);
    track.addEventListener('pointerdown', pauseAutoplay); // touch users can't hover — WCAG 2.2.2

    var resizeT;
    function onResize() {
      window.clearTimeout(resizeT);
      resizeT = window.setTimeout(function () { update(); startAutoplay(); }, 100);
    }
    window.addEventListener('resize', onResize);

    el.moduloTrTeardown = function () {
      pauseAutoplay();
      window.removeEventListener('resize', onResize);
      track.removeEventListener('scroll', onScroll);
      track.removeEventListener('pointerdown', pauseAutoplay);
      el.removeEventListener('mouseenter', pauseAutoplay);
      el.removeEventListener('mouseleave', startAutoplay);
      el.removeEventListener('focusin', pauseAutoplay);
      el.removeEventListener('focusout', startAutoplay);
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      el.dataset.moduloTrInit = '';
    };

    update();
    startAutoplay();
  }

  function initAll() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-tr]', initSection);
    } else {
      var els = document.querySelectorAll('[data-modulo-tr]');
      for (var i = 0; i < els.length; i++) initSection(els[i]);
    }
  }

  function sectionTarget(e) {
    var t = e.target;
    if (!t || !t.querySelector) return null;
    if (t.matches && t.matches('[data-modulo-tr]')) return t;
    return t.querySelector('[data-modulo-tr]');
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = sectionTarget(e);
    if (el) initSection(el);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = sectionTarget(e);
    if (el && typeof el.moduloTrTeardown === 'function') el.moduloTrTeardown();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
